import { combineReducers } from 'redux';

import requests from './requests.reducer';
import auth from './auth.reducer';
import dependents from './dependents.reducer';
import formRequest from './formRequest.reducer';
import recordRequest from './recordRequest.reducer';
import favouriteCustodians from './favouriteCustodians.reducer';
import paymentMethods from './paymentMethods.reducer';
import session from './session.reducer';
import refundRequest from './refundRequest.reducer';
import chats from './chat.reducer'
import subscription from './subscription'
import hippa from './hippa.reducer'
import govtDocument from './govtDocument.reducer'
import common from './common.reducer'
import medicalRecords from './medical_records.reducer';

export const getReducers = () =>
  combineReducers({
    requests,
    auth,
    dependents,
    formRequest,
    recordRequest,
    favouriteCustodians,
    paymentMethods,
    refundRequest,
    session,
    chats,
    subscription,
    hippa,
    govtDocument,
    common,
    medicalRecords
  });

export type RootReducerType = ReturnType<ReturnType<typeof getReducers>>;
